export const GITHUB = "github";
export const LINKEDIN = "linkedin";
export const INSTAGRAM = "instagram";
export const EDIT = "edit";
